// Network configuration from environment variables
export const NETWORK = process.env.REACT_APP_NETWORK || 'mordor'; // 'mordor' or 'mainnet'

// RPC URLs from environment variables with fallbacks
export const RPC_URLS = {
  MORDOR: process.env.REACT_APP_MORDOR_RPC_URL || 'https://rpc.mordor.etccooperative.org',
  MAINNET: process.env.REACT_APP_MAINNET_RPC_URL || 'https://etc.rivet.link',
};

// Get current RPC URL based on network
export const getCurrentRpcUrl = () => {
  return NETWORK === 'mainnet' ? RPC_URLS.MAINNET : RPC_URLS.MORDOR;
};

// Log network configuration on load (for debugging)
if (typeof window !== 'undefined') {
  console.log(`🌐 Network: ${NETWORK}`);
  console.log(`🔗 RPC URL: ${getCurrentRpcUrl()}`);
}

// Contract addresses - can be overridden via environment variables
// Default addresses are for Mordor testnet
export const CONTRACT_ADDRESSES = {
  ETCMCLICENSEV2: process.env.REACT_APP_ETCMCLICENSEV2_ADDRESS || '0x8f09025e5d0a100918E7C259199F3a3C5D2091C9', // UPDATE THIS ADDRESS
  ETCPOW: process.env.REACT_APP_ETCPOW_ADDRESS || '0x6856FE43e43996830526cEd56BbC53f3F6a8E80E',
};

// Mainnet contract addresses (for reference - set via env vars)
export const MAINNET_CONTRACT_ADDRESSES = {
  ETCMCLICENSEV2: process.env.REACT_APP_MAINNET_ETCMCLICENSEV2_ADDRESS || '',
  ETCPOW: process.env.REACT_APP_MAINNET_ETCPOW_ADDRESS || '',
};

export const NETWORKS = {
  MAINNET: 'mainnet',
  TESTNET: 'mordor', // Mordor is the ETC Classic testnet
};

export const GAS_LIMITS = {
  DEFAULT: 200000,
  MINT: 300000,
  APPROVE: 100000,
  TRANSFER: 250000,
};

export const MARKETPLACE_FEE = 0.15; // 15%

// Helper to get contract address based on network
export const getContractAddress = (contractName) => {
  // If on mainnet and mainnet address is configured, use it
  if (NETWORK === 'mainnet') {
    const mainnetAddress = MAINNET_CONTRACT_ADDRESSES[contractName];
    if (mainnetAddress && mainnetAddress.trim() !== '') {
      return mainnetAddress;
    }
  }
  // Otherwise use the default (Mordor) address
  return CONTRACT_ADDRESSES[contractName];
};
